import { render, staticRenderFns } from "./saveblob.vue?vue&type=template&id=12fe1cbe"
import script from "./saveblob.vue?vue&type=script&lang=js"
export * from "./saveblob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports